import React from "react";

export default function SitelHelpDesk() {
  return (
    <a style={{ color: 'black' }} href='tel:855-745-1861'>
      855-745-1861
    </a>
  );
}

export function SitelHelpDeskLanguage() {
  return (
    <>
      please call the MedStar SiTEL Help Desk at <SitelHelpDesk />
    </>
  );
}
